import * as React from 'react';
import { Favourite } from './favourite';
import { FavouriteInstance } from './favourite-context';

interface FavouriteRouteProps {
  location: { query: { report: string, openFilters?: string, editSavedFavourite?: string }};
  params: { favouriteId: string };
}

export function FavouriteRoute({
  location,
  params
}: FavouriteRouteProps) {
  const report = location?.query?.report ?
    parseInt(location.query.report, 10) :
    undefined;
  
  const favouriteId = params?.favouriteId && parseInt(params.favouriteId, 10);

  const intiallyOpenFilter = Boolean(location?.query?.openFilters);

  const editSavedFavourite = Boolean(location?.query?.editSavedFavourite);
  
  return (
    <FavouriteInstance>
      <Favourite
        editSavedFavourite={editSavedFavourite}
        initiallyOpenFilter={intiallyOpenFilter}
        overrideReport={report}
        favouriteId={favouriteId}
      />
    </FavouriteInstance>
  );
}
